<template>
    <div :class="['filter', classes]">
        <div @click="toggle($event)" class="header">
            <h3>{{ $t(title)}}</h3>
            <span class="mdi mdi-chevron-down"></span>
        </div>

        <div class="body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../../services/eventBus';
    export default {
        name: 'Filters',
        props: {
            'title': String,
            'is-open-default': Boolean
        },
        data() {
            return {
                isActive: this.isOpenDefault
            };
        },
        computed: {
            classes() {
                return {
                    'is-active': this.isActive
                }
            }
        },
        methods: {
            open (e) {
                this.isActive = true;
                EventBus.$emit('closeFilterAccordeon', this);
            },

            close (e) {
                this.isActive = false;
            },
            closeFilterIfNeeded(from) {
              if (this !== from) {
                this.close();
              }
            },
            toggle (e) {
                return (this.isActive ? this.close(e) : this.open(e));
            }
        },
        mounted: function() {
          EventBus.$on('closeFilterAccordeon', this.closeFilterIfNeeded)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/elements/Filter.vue